<template>
    <page>
        <fast-table
            v-if="dataLoaded"
            :sections="sections"
            :headers="headers"
            :data="tableData"
            :activeRowId="currentSymTaxId"
            @click="currentSymTaxId = $event.id"
        />

        <sidebar
            :key="currentSymTaxId"
            :sym-tax="currentSymTax"
            v-if="currentSymTaxId"
            @close="currentSymTaxId = null"
            @updated="onSymTaxUpdated"
        />
    </page>
</template>

<script>
import FastTable from '@/components/FastTable'
import Page from '@/components/Page'
import Sidebar from './components/SymTaxSidebar'

export default {
    components: {FastTable, Page, Sidebar},
    computed: {
        currentSymTax() {
            return this.symTaxes.find(t => t.id == this.currentSymTaxId)
        },
        tableData() {
            const sectionData = this.symTaxes.map(t => {
                return {
                    id: t.id,
                    object: t,
                    cells: [
                        t.description,
                        t.tax_type,
                        t.unique_tax_id,
                        t.state_abbreviation || '—',
                    ],
                }
            })
            return [sectionData]
        },
    },
    data() {
        return {
            symTaxes: [],
            dataLoaded: false,
            currentSymTaxId: null,

            headers: [
                {label: 'Name', classes: '', isSearchable: true, defaultSort: true},
                {label: 'Tax Type', classes: 'cw-8', isSearchable: false, isFilterable: true},
                {label: 'Unique Tax ID', classes: 'cw-10', isSearchable: true},
                {label: 'State', classes: 'cw-3', isSearchable: false, isFilterable: true},
            ],
            sections: [
                {title: '', defaultIsClosed: false, id: 1},
            ],
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Tax Engine / Sym Taxes')
        this.getData()
    },
    methods: {
        onSymTaxUpdated(symTax) {
            const idx = this.symTaxes.findIndex(t => t.id == symTax.id)
            if (idx >= 0) {
                this.symTaxes.splice(idx, 1, symTax)
            }
        },
        getData() {
            this.dataLoaded = false
            this.$store.dispatch('START_LOADING')
            this.$api.get('/admin/tax-engine/sym-taxes').then(resp => {
                this.symTaxes = resp
                this.dataLoaded = true
                this.$store.dispatch('STOP_LOADING')
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
    },
}
</script>
